class Direction {
  static LEFT = "left";
  static RIGHT = "right";
  static UP = "up";
  static DOWN = "down";
}

export default Direction;
